/**
 * Created with Mei Zhiwei on 2018-07-19 15:49:46.
 * Description: 业务类型
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-07-19 15:51:41
 */
export const bizTypes = {
  10: '厂商 API',
  20: '桌台 API',
  30: '菜品 API',
  40: '订单 API'
};



// WEBPACK FOOTER //
// ./src/config/bizTypes.js